import i18n from 'i18nconfig';
import a4QuestionsImg from '../assets/img/pages/blog/bulk_printing_a4.png';
import botScreenplayImg from '../assets/img/pages/blog/bot_to_write.png';
import resignationImg from '../assets/img/pages/blog/resignation_letter.png';
import menuPrintingImg from '../assets/img/pages/blog/How_to_print_menus.png';
import environmentPrintersImg from '../assets/img/pages/blog/company_printers.png';
import visaApplicationsImg from '../assets/img/pages/blog/cover_visa.jpg';
import wellnessJournalImg from '../assets/img/pages/blog/Wellness_journal_cover.png';
import printerCostImg from '../assets/img/pages/blog/how_much_does_a_printer_truly_cost.png';
import projectPrintingImg from '../assets/img/pages/blog/perfectiong_project_printing.png';
import printVsOnlineImg from '../assets/img/pages/blog/prtint_vs_online.png';
import environmentallyFriendlyImg from '../assets/img/pages/blog/printing_environmentally_friendly.png';
import historyPrintingImg from '../assets/img/pages/blog/history_of_printing.png';
import writeA4Img from '../assets/img/pages/blog/How_to_write_for_A4_Print.png';
import designA4Img from '../assets/img/pages/blog/How_to_design_for_A4_Print.png';
import oldPaperImg from '../assets/img/pages/blog/6_things_to_do.png';
import digitalEraImg from '../assets/img/pages/blog/printing_in_the_digital_era.png';
import droneDelivery from '../assets/img/pages/blog/drone_delivery.png';
import psychologyReadingImg from '../assets/img/pages/blog/the_psyhology_of_reading.png';
import artEditingImg from '../assets/img/pages/blog/the_art_of_editing.png';
import ruslanImg from '../assets/img/pages/blog/ruslan.png';
import printingIn2025Img from '../assets/img/pages/blog/articles/printing2025/printing-2025-hero.jpg';
import printingIn2025ImgEn from '../assets/img/pages/blog/articles/printing2025/printing-2025-hero-en.jpg';

// Book binding images
import bookBindingHeroImageEn from '../assets/img/pages/bookBinding/BookBinding_en.png';
import bookBindingHeroImageBg from '../assets/img/pages/bookBinding/BookBinding_bg.png';

// Color printing images
import colorPrintingImageEn from '../assets/img/pages/colorPrinting/ColorPrinting_en.png';
import colorPrintingImageBg from '../assets/img/pages/colorPrinting/ColorPrinting_bg.png';

// Book printing images
import bookPrintingHeroImageEn from '../assets/img/pages/bookPrinting/BookPrinting_en.png';
import bookPrintingHeroImageBg from '../assets/img/pages/bookPrinting/BookPrinting_bg.png';

import { BlogPost } from '../types/blog';

// Create a function to sort blog posts by date
const sortBlogPostsByDate = (posts: BlogPost[]) => {
  return posts.sort((a, b) => {
    const dateA = new Date(a.publishDate);
    const dateB = new Date(b.publishDate);
    return dateB.getTime() - dateA.getTime(); // Newest first
  });
};

// Export function to get blog posts with current language
export const getBlogPosts = (): BlogPost[] => {
  const unsortedPosts: BlogPost[] = [
    // Newest post - Printing in 2025 (latest post by Philip Balkanski)
    {
      id: 22,
      slug: 'printing-in-2025',
      title: i18n.t('blog.post.printing-in-2025.title'),
      excerpt: i18n.t('blog.post.printing-in-2025.excerpt'),
      content: i18n.t('blog.post.printing-in-2025.content'),
      image: i18n.language === 'bg' ? printingIn2025Img : printingIn2025ImgEn,
      publishDate: i18n.t('blog.post.printing-in-2025.publishDate'),
      author: i18n.t('blog.post.printing-in-2025.author'),
    },
    // Book binding guide
    {
      id: 23,
      slug: 'book-binding-guide',
      title: i18n.t('blog.post.book-binding-guide.title'),
      excerpt: i18n.t('blog.post.book-binding-guide.excerpt'),
      content: i18n.t('blog.post.book-binding-guide.content'),
      image: i18n.language === 'bg' ? bookBindingHeroImageBg : bookBindingHeroImageEn,
      publishDate: i18n.t('blog.post.book-binding-guide.publishDate'),
      author: i18n.t('blog.post.book-binding-guide.author'),
    },
    // Color printing guide
    {
      id: 24,
      slug: 'color-printing-guide',
      title: i18n.t('blog.post.color-printing-guide.title'),
      excerpt: i18n.t('blog.post.color-printing-guide.excerpt'),
      content: i18n.t('blog.post.color-printing-guide.content'),
      image: i18n.language === 'bg' ? colorPrintingImageBg : colorPrintingImageEn,
      publishDate: i18n.t('blog.post.color-printing-guide.publishDate'),
      author: i18n.t('blog.post.color-printing-guide.author'),
    },
    // Book printing guide
    {
      id: 25,
      slug: 'book-printing-guide',
      title: i18n.t('blog.post.book-printing-guide.title'),
      excerpt: i18n.t('blog.post.book-printing-guide.excerpt'),
      content: i18n.t('blog.post.book-printing-guide.content'),
      image: i18n.language === 'bg' ? bookPrintingHeroImageBg : bookPrintingHeroImageEn,
      publishDate: i18n.t('blog.post.book-printing-guide.publishDate'),
      author: i18n.t('blog.post.book-printing-guide.author'),
    },
    {
      id: 1,
      slug: 'your-most-common-a4-paper-printing-questions-answered',
      title: i18n.t('blog.post.your-most-common-a4-paper-printing-questions-answered.title'),
      excerpt: i18n.t('blog.post.your-most-common-a4-paper-printing-questions-answered.excerpt'),
      content: i18n.t('blog.post.your-most-common-a4-paper-printing-questions-answered.content'),
      image: droneDelivery,
      publishDate: i18n.t('blog.post.your-most-common-a4-paper-printing-questions-answered.publishDate'),
      author: i18n.t('blog.post.your-most-common-a4-paper-printing-questions-answered.author'),
    },
    {
      id: 2,
      slug: 'we-asked-a-bot-to-write-a-screenplay-about-home-printing',
      title: i18n.t('blog.post.we-asked-a-bot-to-write-a-screenplay-about-home-printing.title'),
      excerpt: i18n.t('blog.post.we-asked-a-bot-to-write-a-screenplay-about-home-printing.excerpt'),
      content: i18n.t('blog.post.we-asked-a-bot-to-write-a-screenplay-about-home-printing.content'),
      image: botScreenplayImg,
      publishDate: i18n.t('blog.post.we-asked-a-bot-to-write-a-screenplay-about-home-printing.publishDate'),
      author: i18n.t('blog.post.we-asked-a-bot-to-write-a-screenplay-about-home-printing.author'),
    },
    {
      id: 3,
      slug: 'a-resignation-letter-from-your-printer',
      title: i18n.t('blog.post.a-resignation-letter-from-your-printer.title'),
      excerpt: i18n.t('blog.post.a-resignation-letter-from-your-printer.excerpt'),
      content: i18n.t('blog.post.a-resignation-letter-from-your-printer.content'),
      image: resignationImg,
      publishDate: i18n.t('blog.post.a-resignation-letter-from-your-printer.publishDate'),
      author: i18n.t('blog.post.a-resignation-letter-from-your-printer.author'),
    },
    {
      id: 4,
      slug: 'a-guide-to-bulk-printing-a4',
      title: i18n.t('blog.post.a-guide-to-bulk-printing-a4.title'),
      excerpt: i18n.t('blog.post.a-guide-to-bulk-printing-a4.excerpt'),
      content: i18n.t('blog.post.a-guide-to-bulk-printing-a4.content'),
      image: a4QuestionsImg,
      publishDate: i18n.t('blog.post.a-guide-to-bulk-printing-a4.publishDate'),
      author: i18n.t('blog.post.a-guide-to-bulk-printing-a4.author'),
    },
    {
      id: 5,
      slug: 'a-quick-guide-to-restaurant-menu-printing',
      title: i18n.t('blog.post.a-quick-guide-to-restaurant-menu-printing.title'),
      excerpt: i18n.t('blog.post.a-quick-guide-to-restaurant-menu-printing.excerpt'),
      content: i18n.t('blog.post.a-quick-guide-to-restaurant-menu-printing.content'),
      image: menuPrintingImg,
      publishDate: i18n.t('blog.post.a-quick-guide-to-restaurant-menu-printing.publishDate'),
      author: i18n.t('blog.post.a-quick-guide-to-restaurant-menu-printing.author'),
    },
    {
      id: 6,
      slug: 'how-do-company-printers-affect-the-environment',
      title: i18n.t('blog.post.how-do-company-printers-affect-the-environment.title'),
      excerpt: i18n.t('blog.post.how-do-company-printers-affect-the-environment.excerpt'),
      content: i18n.t('blog.post.how-do-company-printers-affect-the-environment.content'),
      image: environmentPrintersImg,
      publishDate: i18n.t('blog.post.how-do-company-printers-affect-the-environment.publishDate'),
      author: i18n.t('blog.post.how-do-company-printers-affect-the-environment.author'),
    },
    {
      id: 7,
      slug: 'printt-visa-applications-top-5-things-to-remember',
      title: i18n.t('blog.post.printt-visa-applications-top-5-things-to-remember.title'),
      excerpt: i18n.t('blog.post.printt-visa-applications-top-5-things-to-remember.excerpt'),
      content: i18n.t('blog.post.printt-visa-applications-top-5-things-to-remember.content'),
      image: visaApplicationsImg,
      publishDate: i18n.t('blog.post.printt-visa-applications-top-5-things-to-remember.publishDate'),
      author: i18n.t('blog.post.printt-visa-applications-top-5-things-to-remember.author'),
    },
    {
      id: 8,
      slug: 'printt-your-way-to-wellness-with-this-free-printable-wellness-journal',
      title: i18n.t('blog.post.printt-your-way-to-wellness-with-this-free-printable-wellness-journal.title'),
      excerpt: i18n.t('blog.post.printt-your-way-to-wellness-with-this-free-printable-wellness-journal.excerpt'),
      content: i18n.t('blog.post.printt-your-way-to-wellness-with-this-free-printable-wellness-journal.content'),
      image: wellnessJournalImg,
      publishDate: i18n.t(
        'blog.post.printt-your-way-to-wellness-with-this-free-printable-wellness-journal.publishDate',
      ),
      author: i18n.t('blog.post.printt-your-way-to-wellness-with-this-free-printable-wellness-journal.author'),
    },
    {
      id: 9,
      slug: 'how-much-does-a-printer-truly-cost-your-business',
      title: i18n.t('blog.post.how-much-does-a-printer-truly-cost-your-business.title'),
      excerpt: i18n.t('blog.post.how-much-does-a-printer-truly-cost-your-business.excerpt'),
      content: i18n.t('blog.post.how-much-does-a-printer-truly-cost-your-business.content'),
      image: printerCostImg,
      publishDate: i18n.t('blog.post.how-much-does-a-printer-truly-cost-your-business.publishDate'),
      author: i18n.t('blog.post.how-much-does-a-printer-truly-cost-your-business.author'),
    },
    {
      id: 10,
      slug: 'perfecting-your-project-for-online-printing',
      title: i18n.t('blog.post.perfecting-your-project-for-online-printing.title'),
      excerpt: i18n.t('blog.post.perfecting-your-project-for-online-printing.excerpt'),
      content: i18n.t('blog.post.perfecting-your-project-for-online-printing.content'),
      image: projectPrintingImg,
      publishDate: i18n.t('blog.post.perfecting-your-project-for-online-printing.publishDate'),
      author: i18n.t('blog.post.perfecting-your-project-for-online-printing.author'),
    },
    {
      id: 11,
      slug: 'print-vs-online-how-to-shape-a-project-for-the-medium',
      title: i18n.t('blog.post.print-vs-online-how-to-shape-a-project-for-the-medium.title'),
      excerpt: i18n.t('blog.post.print-vs-online-how-to-shape-a-project-for-the-medium.excerpt'),
      content: i18n.t('blog.post.print-vs-online-how-to-shape-a-project-for-the-medium.content'),
      image: printVsOnlineImg,
      publishDate: i18n.t('blog.post.print-vs-online-how-to-shape-a-project-for-the-medium.publishDate'),
      author: i18n.t('blog.post.print-vs-online-how-to-shape-a-project-for-the-medium.author'),
    },
    {
      id: 12,
      slug: 'how-to-keep-your-printing-environmentally-friendly',
      title: i18n.t('blog.post.how-to-keep-your-printing-environmentally-friendly.title'),
      excerpt: i18n.t('blog.post.how-to-keep-your-printing-environmentally-friendly.excerpt'),
      content: i18n.t('blog.post.how-to-keep-your-printing-environmentally-friendly.content'),
      image: environmentallyFriendlyImg,
      publishDate: i18n.t('blog.post.how-to-keep-your-printing-environmentally-friendly.publishDate'),
      author: i18n.t('blog.post.how-to-keep-your-printing-environmentally-friendly.author'),
    },
    {
      id: 13,
      slug: 'from-woodblock-to-wi-fi-history-of-printing',
      title: i18n.t('blog.post.from-woodblock-to-wi-fi-history-of-printing.title'),
      excerpt: i18n.t('blog.post.from-woodblock-to-wi-fi-history-of-printing.excerpt'),
      content: i18n.t('blog.post.from-woodblock-to-wi-fi-history-of-printing.content'),
      image: historyPrintingImg,
      publishDate: i18n.t('blog.post.from-woodblock-to-wi-fi-history-of-printing.publishDate'),
      author: i18n.t('blog.post.from-woodblock-to-wi-fi-history-of-printing.author'),
    },
    {
      id: 14,
      slug: 'how-to-write-for-a4-print',
      title: i18n.t('blog.post.how-to-write-for-a4-print.title'),
      excerpt: i18n.t('blog.post.how-to-write-for-a4-print.excerpt'),
      content: i18n.t('blog.post.how-to-write-for-a4-print.content'),
      image: writeA4Img,
      publishDate: i18n.t('blog.post.how-to-write-for-a4-print.publishDate'),
      author: i18n.t('blog.post.how-to-write-for-a4-print.author'),
    },
    {
      id: 15,
      slug: 'how-to-design-for-a4-print',
      title: i18n.t('blog.post.how-to-design-for-a4-print.title'),
      excerpt: i18n.t('blog.post.how-to-design-for-a4-print.excerpt'),
      content: i18n.t('blog.post.how-to-design-for-a4-print.content'),
      image: designA4Img,
      publishDate: i18n.t('blog.post.how-to-design-for-a4-print.publishDate'),
      author: i18n.t('blog.post.how-to-design-for-a4-print.author'),
    },
    {
      id: 16,
      slug: '6-things-to-do-with-old-paper-before-you-recycle-it',
      title: i18n.t('blog.post.6-things-to-do-with-old-paper-before-you-recycle-it.title'),
      excerpt: i18n.t('blog.post.6-things-to-do-with-old-paper-before-you-recycle-it.excerpt'),
      content: i18n.t('blog.post.6-things-to-do-with-old-paper-before-you-recycle-it.content'),
      image: oldPaperImg,
      publishDate: i18n.t('blog.post.6-things-to-do-with-old-paper-before-you-recycle-it.publishDate'),
      author: i18n.t('blog.post.6-things-to-do-with-old-paper-before-you-recycle-it.author'),
    },
    {
      id: 17,
      slug: 'printing-in-the-digital-era',
      title: i18n.t('blog.post.printing-in-the-digital-era.title'),
      excerpt: i18n.t('blog.post.printing-in-the-digital-era.excerpt'),
      content: i18n.t('blog.post.printing-in-the-digital-era.content'),
      image: digitalEraImg,
      publishDate: i18n.t('blog.post.printing-in-the-digital-era.publishDate'),
      author: i18n.t('blog.post.printing-in-the-digital-era.author'),
    },
    {
      id: 18,
      slug: 'uk-scale-up-printt-raises-1-million',
      title: i18n.t('blog.post.uk-scale-up-printt-raises-1-million.title'),
      excerpt: i18n.t('blog.post.uk-scale-up-printt-raises-1-million.excerpt'),
      content: i18n.t('blog.post.uk-scale-up-printt-raises-1-million.content'),
      image: ruslanImg,
      publishDate: i18n.t('blog.post.uk-scale-up-printt-raises-1-million.publishDate'),
      author: i18n.t('blog.post.uk-scale-up-printt-raises-1-million.author'),
    },
    {
      id: 19,
      slug: 'the-psychology-of-reading-print',
      title: i18n.t('blog.post.the-psychology-of-reading-print.title'),
      excerpt: i18n.t('blog.post.the-psychology-of-reading-print.excerpt'),
      content: i18n.t('blog.post.the-psychology-of-reading-print.content'),
      image: psychologyReadingImg,
      publishDate: i18n.t('blog.post.the-psychology-of-reading-print.publishDate'),
      author: i18n.t('blog.post.the-psychology-of-reading-print.author'),
    },
    {
      id: 20,
      slug: 'the-art-of-editing',
      title: i18n.t('blog.post.the-art-of-editing.title'),
      excerpt: i18n.t('blog.post.the-art-of-editing.excerpt'),
      content: i18n.t('blog.post.the-art-of-editing.content'),
      image: artEditingImg,
      publishDate: i18n.t('blog.post.the-art-of-editing.publishDate'),
      author: i18n.t('blog.post.the-art-of-editing.author'),
    },
  ];

  // Return sorted blog posts (newest first)
  return sortBlogPostsByDate(unsortedPosts);
};

// For backward compatibility, export a default array using getBlogPosts
export const blogPosts: BlogPost[] = getBlogPosts();
